import { render, staticRenderFns } from "./applyForTrial.vue?vue&type=template&id=876288f2&scoped=true"
import script from "./applyForTrial.vue?vue&type=script&lang=js"
export * from "./applyForTrial.vue?vue&type=script&lang=js"
import style0 from "./applyForTrial.vue?vue&type=style&index=0&id=876288f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876288f2",
  null
  
)

export default component.exports